// Generated by `bun run --filter @esi/api routes:record` (apps/api/src/api-routes.test.ts): do not edit.
export const API_ROUTE_TEMPLATES: readonly string[] = [
  "/api/account",
  "/api/account/connected-apps",
  "/api/account/connected-apps/:id",
  "/api/account/esi-credential",
  "/api/account/mcp",
  "/api/account/passkeys",
  "/api/account/passkeys/:id",
  "/api/account/passkeys/options",
  "/api/account/password",
  "/api/account/preferences",
  "/api/account/profile",
  "/api/account/reauth",
  "/api/account/reauth/passkey",
  "/api/account/reauth/passkey/options",
  "/api/account/sessions",
  "/api/account/sessions/:id",
  "/api/account/sessions/revoke-others",
  "/api/account/totp",
  "/api/account/totp/verify",
  "/api/admin/access-requests",
  "/api/admin/access-requests/:id/reason",
  "/api/admin/audit",
  "/api/admin/branding",
  "/api/admin/branding/logo/:id",
  "/api/admin/classification/usage",
  "/api/admin/declassifications",
  "/api/admin/directory/attributes",
  "/api/admin/directory/attributes/:id",
  "/api/admin/directory/groups",
  "/api/admin/directory/groups/:id",
  "/api/admin/directory/org-codes",
  "/api/admin/directory/org-codes/:id",
  "/api/admin/directory/rules",
  "/api/admin/directory/rules/:id",
  "/api/admin/directory/sources",
  "/api/admin/directory/sources/:id",
  "/api/admin/directory/sources/:id/credential",
  "/api/admin/directory/sources/:id/sync",
  "/api/admin/directory/sources/:id/test",
  "/api/admin/directory/sources/:id/token",
  "/api/admin/directory/unmapped",
  "/api/admin/domains",
  "/api/admin/domains/:id",
  "/api/admin/domains/:id/release",
  "/api/admin/domains/:id/sign-in-mode",
  "/api/admin/domains/:id/sign-in-mode/preview",
  "/api/admin/domains/:id/verify",
  "/api/admin/entities",
  "/api/admin/entities/:id",
  "/api/admin/entities/:id/members",
  "/api/admin/entities/:id/members/:id",
  "/api/admin/entities/:id/members/:id/roles",
  "/api/admin/entities/:id/settings",
  "/api/admin/entities/:id/settings/:id",
  "/api/admin/identity-providers",
  "/api/admin/identity-providers/:id",
  "/api/admin/identity-providers/:id/removal",
  "/api/admin/identity-providers/:id/remove",
  "/api/admin/memory",
  "/api/admin/model-health",
  "/api/admin/model-health/check",
  "/api/admin/model-health/refresh",
  "/api/admin/model-switches",
  "/api/admin/models",
  "/api/admin/models/:id/consent",
  "/api/admin/oauth-clients",
  "/api/admin/ocr-usage",
  "/api/admin/plan",
  "/api/admin/projects",
  "/api/admin/projects/:id",
  "/api/admin/projects/:id/break-glass",
  "/api/admin/projects/:id/freeze",
  "/api/admin/projects/:id/groups",
  "/api/admin/projects/:id/groups/:id",
  "/api/admin/projects/:id/members",
  "/api/admin/projects/:id/members/:id",
  "/api/admin/projects/:id/memories",
  "/api/admin/projects/:id/owner",
  "/api/admin/projects/:id/rules/:id",
  "/api/admin/projects/:id/settings/:id",
  "/api/admin/projects/:id/transfer",
  "/api/admin/projects/:id/unfreeze",
  "/api/admin/reports/cost",
  "/api/admin/reports/health",
  "/api/admin/reports/quality",
  "/api/admin/reports/recommendations",
  "/api/admin/reports/usage",
  "/api/admin/residency",
  "/api/admin/settings",
  "/api/admin/settings/:id",
  "/api/admin/settings/catalogue",
  "/api/admin/support-grants",
  "/api/admin/support-grants/:id/approve",
  "/api/admin/support-grants/:id/content",
  "/api/admin/support-grants/:id/refuse",
  "/api/admin/support-grants/:id/revoke",
  "/api/admin/users",
  "/api/admin/users/:id",
  "/api/admin/users/:id/connected-apps",
  "/api/admin/users/:id/connected-apps/:id",
  "/api/admin/users/:id/esi-credential",
  "/api/admin/users/:id/invitation-link",
  "/api/admin/users/:id/memories/count",
  "/api/admin/users/:id/memories/erase",
  "/api/admin/users/:id/mfa-reset",
  "/api/auth/callback",
  "/api/auth/challenge",
  "/api/auth/csrf",
  "/api/auth/enrol/passkey",
  "/api/auth/enrol/passkey/options",
  "/api/auth/enrol/totp",
  "/api/auth/enrol/totp/verify",
  "/api/auth/invitation",
  "/api/auth/invitation/check",
  "/api/auth/invitation/resend",
  "/api/auth/login",
  "/api/auth/logout",
  "/api/auth/operator/challenge",
  "/api/auth/operator/csrf",
  "/api/auth/operator/enrol/totp",
  "/api/auth/operator/enrol/totp/verify",
  "/api/auth/operator/passkey",
  "/api/auth/operator/passkey/options",
  "/api/auth/operator/password",
  "/api/auth/operator/start",
  "/api/auth/passkey",
  "/api/auth/passkey/options",
  "/api/auth/password",
  "/api/auth/refederate",
  "/api/auth/reset",
  "/api/auth/reset/check",
  "/api/auth/reset/request",
  "/api/auth/session",
  "/api/auth/signup",
  "/api/auth/start",
  "/api/branding/logo/:id/:id/:id",
  "/api/client-events",
  "/api/conversations",
  "/api/conversations/:id",
  "/api/conversations/:id/archive",
  "/api/conversations/:id/artefacts",
  "/api/conversations/:id/artefacts/:id/versions/:id",
  "/api/conversations/:id/artefacts/:id/versions/:id/download",
  "/api/conversations/:id/artefacts/:id/versions/:id/file",
  "/api/conversations/:id/artefacts/:id/versions/:id/knowledge",
  "/api/conversations/:id/artefacts/:id/versions/:id/knowledge/update",
  "/api/conversations/:id/artefacts/:id/versions/:id/preview",
  "/api/conversations/:id/attachments",
  "/api/conversations/:id/attachments/:id",
  "/api/conversations/:id/attachments/:id/confirm",
  "/api/conversations/:id/attachments/:id/download",
  "/api/conversations/:id/attachments/:id/open",
  "/api/conversations/:id/attachments/:id/retry",
  "/api/conversations/:id/attachments/:id/view",
  "/api/conversations/:id/messages",
  "/api/conversations/:id/messages/:id/citations/:id",
  "/api/conversations/:id/messages/:id/save",
  "/api/conversations/:id/messages/:id/title",
  "/api/conversations/:id/messages/:id/wiki",
  "/api/conversations/:id/model-options",
  "/api/conversations/:id/move",
  "/api/conversations/:id/project-share",
  "/api/conversations/:id/share-candidates",
  "/api/conversations/:id/shares",
  "/api/conversations/:id/shares/:id",
  "/api/conversations/:id/tool-approvals/:id",
  "/api/conversations/:id/wiki-suggestions/:id/accept",
  "/api/conversations/:id/wiki-suggestions/:id/dismiss",
  "/api/conversations/:id/wiki-suggestions/:id/pages/:id",
  "/api/csp-reports",
  "/api/directory/batch",
  "/api/directory/snapshot",
  "/api/directory/users/:id/groups",
  "/api/feedback",
  "/api/feedback/:id/screenshot",
  "/api/feedback/:id/screenshot/confirm",
  "/api/feedback/drafts",
  "/api/feedback/drafts/:id/dismiss",
  "/api/feedback/drafts/:id/send",
  "/api/health",
  "/api/me",
  "/api/me/conversations",
  "/api/me/feedback",
  "/api/me/feedback/:id/screenshot",
  "/api/me/principals",
  "/api/me/settings",
  "/api/me/tasks",
  "/api/me/wiki-notifications",
  "/api/me/wiki-notifications/read",
  "/api/memories",
  "/api/memories/:id",
  "/api/memories/delete-all",
  "/api/memories/export",
  "/api/memories/proposals/:id/accept",
  "/api/memories/proposals/:id/dismiss",
  "/api/model-options",
  "/api/oauth/interaction/:id",
  "/api/oauth/interaction/:id/confirm",
  "/api/oauth/interaction/:id/deny",
  "/api/oauth/interaction/:id/details",
  "/api/oauth/verify/confirm",
  "/api/oauth/verify/deny",
  "/api/oauth/verify/lookup",
  "/api/operator/account/passkeys",
  "/api/operator/account/passkeys/:id",
  "/api/operator/account/passkeys/options",
  "/api/operator/account/profile",
  "/api/operator/account/reauth",
  "/api/operator/account/reauth/passkey",
  "/api/operator/account/reauth/passkey/options",
  "/api/operator/feedback",
  "/api/operator/feedback-assist/spend",
  "/api/operator/feedback-grouping",
  "/api/operator/feedback-grouping/:id",
  "/api/operator/feedback-groups",
  "/api/operator/feedback-groups/:id",
  "/api/operator/feedback-groups/:id/draft",
  "/api/operator/feedback-groups/:id/fingerprints",
  "/api/operator/feedback-groups/:id/fingerprints/:id",
  "/api/operator/feedback-groups/:id/issue",
  "/api/operator/feedback-suggestions/:id/decision",
  "/api/operator/feedback-tracker",
  "/api/operator/feedback/:id",
  "/api/operator/feedback/:id/screenshot",
  "/api/operator/feedback/:id/suggest",
  "/api/operator/feedback/suggest",
  "/api/operator/model-accounts",
  "/api/operator/model-accounts/:id",
  "/api/operator/model-connections",
  "/api/operator/model-connections/:id",
  "/api/operator/model-connections/:id/probe",
  "/api/operator/model-connections/:id/setup",
  "/api/operator/model-health",
  "/api/operator/model-health/check",
  "/api/operator/model-health/refresh",
  "/api/operator/model-labs",
  "/api/operator/plans",
  "/api/operator/plans/:id",
  "/api/operator/policies",
  "/api/operator/policies/:id",
  "/api/operator/reports/cost",
  "/api/operator/reports/health",
  "/api/operator/reports/quality",
  "/api/operator/reports/usage",
  "/api/operator/residency",
  "/api/operator/sessions",
  "/api/operator/sessions/:id",
  "/api/operator/support",
  "/api/operator/support/:id",
  "/api/operator/support/:id/admin/access-requests",
  "/api/operator/support/:id/admin/access-requests/:id/reason",
  "/api/operator/support/:id/admin/audit",
  "/api/operator/support/:id/admin/branding",
  "/api/operator/support/:id/admin/branding/logo/:id",
  "/api/operator/support/:id/admin/classification/usage",
  "/api/operator/support/:id/admin/directory/attributes",
  "/api/operator/support/:id/admin/directory/attributes/:id",
  "/api/operator/support/:id/admin/directory/groups",
  "/api/operator/support/:id/admin/directory/groups/:id",
  "/api/operator/support/:id/admin/directory/org-codes",
  "/api/operator/support/:id/admin/directory/org-codes/:id",
  "/api/operator/support/:id/admin/directory/rules",
  "/api/operator/support/:id/admin/directory/rules/:id",
  "/api/operator/support/:id/admin/directory/sources",
  "/api/operator/support/:id/admin/directory/sources/:id",
  "/api/operator/support/:id/admin/directory/sources/:id/credential",
  "/api/operator/support/:id/admin/directory/sources/:id/sync",
  "/api/operator/support/:id/admin/directory/sources/:id/test",
  "/api/operator/support/:id/admin/directory/sources/:id/token",
  "/api/operator/support/:id/admin/directory/unmapped",
  "/api/operator/support/:id/admin/domains",
  "/api/operator/support/:id/admin/domains/:id",
  "/api/operator/support/:id/admin/domains/:id/release",
  "/api/operator/support/:id/admin/domains/:id/sign-in-mode",
  "/api/operator/support/:id/admin/domains/:id/sign-in-mode/preview",
  "/api/operator/support/:id/admin/domains/:id/verify",
  "/api/operator/support/:id/admin/entities",
  "/api/operator/support/:id/admin/entities/:id",
  "/api/operator/support/:id/admin/entities/:id/members",
  "/api/operator/support/:id/admin/entities/:id/members/:id",
  "/api/operator/support/:id/admin/entities/:id/members/:id/roles",
  "/api/operator/support/:id/admin/entities/:id/settings",
  "/api/operator/support/:id/admin/entities/:id/settings/:id",
  "/api/operator/support/:id/admin/identity-providers",
  "/api/operator/support/:id/admin/identity-providers/:id",
  "/api/operator/support/:id/admin/identity-providers/:id/removal",
  "/api/operator/support/:id/admin/identity-providers/:id/remove",
  "/api/operator/support/:id/admin/memory",
  "/api/operator/support/:id/admin/model-health",
  "/api/operator/support/:id/admin/model-health/check",
  "/api/operator/support/:id/admin/model-health/refresh",
  "/api/operator/support/:id/admin/model-switches",
  "/api/operator/support/:id/admin/models",
  "/api/operator/support/:id/admin/models/:id/consent",
  "/api/operator/support/:id/admin/oauth-clients",
  "/api/operator/support/:id/admin/ocr-usage",
  "/api/operator/support/:id/admin/plan",
  "/api/operator/support/:id/admin/projects",
  "/api/operator/support/:id/admin/projects/:id",
  "/api/operator/support/:id/admin/projects/:id/break-glass",
  "/api/operator/support/:id/admin/projects/:id/freeze",
  "/api/operator/support/:id/admin/projects/:id/groups",
  "/api/operator/support/:id/admin/projects/:id/groups/:id",
  "/api/operator/support/:id/admin/projects/:id/members",
  "/api/operator/support/:id/admin/projects/:id/members/:id",
  "/api/operator/support/:id/admin/projects/:id/memories",
  "/api/operator/support/:id/admin/projects/:id/owner",
  "/api/operator/support/:id/admin/projects/:id/rules/:id",
  "/api/operator/support/:id/admin/projects/:id/settings/:id",
  "/api/operator/support/:id/admin/projects/:id/transfer",
  "/api/operator/support/:id/admin/projects/:id/unfreeze",
  "/api/operator/support/:id/admin/reports/cost",
  "/api/operator/support/:id/admin/reports/health",
  "/api/operator/support/:id/admin/reports/quality",
  "/api/operator/support/:id/admin/reports/recommendations",
  "/api/operator/support/:id/admin/reports/usage",
  "/api/operator/support/:id/admin/residency",
  "/api/operator/support/:id/admin/settings",
  "/api/operator/support/:id/admin/settings/:id",
  "/api/operator/support/:id/admin/settings/catalogue",
  "/api/operator/support/:id/admin/users",
  "/api/operator/support/:id/admin/users/:id",
  "/api/operator/support/:id/admin/users/:id/connected-apps",
  "/api/operator/support/:id/admin/users/:id/connected-apps/:id",
  "/api/operator/support/:id/admin/users/:id/esi-credential",
  "/api/operator/support/:id/admin/users/:id/invitation-link",
  "/api/operator/support/:id/admin/users/:id/memories/count",
  "/api/operator/support/:id/admin/users/:id/memories/erase",
  "/api/operator/support/:id/admin/users/:id/mfa-reset",
  "/api/operator/support/:id/projects",
  "/api/operator/support/:id/projects/:id",
  "/api/operator/support/:id/projects/:id/access-requests",
  "/api/operator/support/:id/projects/:id/access-requests/:id/approve",
  "/api/operator/support/:id/projects/:id/access-requests/:id/reject",
  "/api/operator/support/:id/projects/:id/activity",
  "/api/operator/support/:id/projects/:id/conversations",
  "/api/operator/support/:id/projects/:id/conversations/:id",
  "/api/operator/support/:id/projects/:id/conversations/:id/artefacts",
  "/api/operator/support/:id/projects/:id/conversations/:id/artefacts/:id/versions/:id",
  "/api/operator/support/:id/projects/:id/conversations/:id/artefacts/:id/versions/:id/download",
  "/api/operator/support/:id/projects/:id/conversations/:id/artefacts/:id/versions/:id/file",
  "/api/operator/support/:id/projects/:id/conversations/:id/artefacts/:id/versions/:id/knowledge",
  "/api/operator/support/:id/projects/:id/conversations/:id/artefacts/:id/versions/:id/knowledge/update",
  "/api/operator/support/:id/projects/:id/conversations/:id/artefacts/:id/versions/:id/preview",
  "/api/operator/support/:id/projects/:id/conversations/:id/messages",
  "/api/operator/support/:id/projects/:id/conversations/:id/messages/:id/citations/:id",
  "/api/operator/support/:id/projects/:id/conversations/:id/messages/:id/save",
  "/api/operator/support/:id/projects/:id/conversations/:id/messages/:id/wiki",
  "/api/operator/support/:id/projects/:id/conversations/:id/project-share",
  "/api/operator/support/:id/projects/:id/conversations/:id/shares",
  "/api/operator/support/:id/projects/:id/conversations/:id/shares/:id",
  "/api/operator/support/:id/projects/:id/conversations/:id/task-proposals/:id/apply",
  "/api/operator/support/:id/projects/:id/conversations/:id/task-proposals/:id/dismiss",
  "/api/operator/support/:id/projects/:id/conversations/:id/tool-approvals/:id",
  "/api/operator/support/:id/projects/:id/conversations/:id/wiki-suggestions/:id/accept",
  "/api/operator/support/:id/projects/:id/conversations/:id/wiki-suggestions/:id/dismiss",
  "/api/operator/support/:id/projects/:id/conversations/:id/wiki-suggestions/:id/pages/:id",
  "/api/operator/support/:id/projects/:id/declassifications",
  "/api/operator/support/:id/projects/:id/declassifications/:id/withdraw",
  "/api/operator/support/:id/projects/:id/documents",
  "/api/operator/support/:id/projects/:id/documents/:id",
  "/api/operator/support/:id/projects/:id/documents/:id/confirm",
  "/api/operator/support/:id/projects/:id/documents/:id/download",
  "/api/operator/support/:id/projects/:id/documents/:id/folder",
  "/api/operator/support/:id/projects/:id/documents/:id/open",
  "/api/operator/support/:id/projects/:id/documents/:id/retry",
  "/api/operator/support/:id/projects/:id/documents/:id/view",
  "/api/operator/support/:id/projects/:id/folders",
  "/api/operator/support/:id/projects/:id/folders/:id",
  "/api/operator/support/:id/projects/:id/folders/:id/move",
  "/api/operator/support/:id/projects/:id/members",
  "/api/operator/support/:id/projects/:id/members/:id",
  "/api/operator/support/:id/projects/:id/members/groups",
  "/api/operator/support/:id/projects/:id/members/groups/:id",
  "/api/operator/support/:id/projects/:id/members/search",
  "/api/operator/support/:id/projects/:id/memories",
  "/api/operator/support/:id/projects/:id/memories/:id",
  "/api/operator/support/:id/projects/:id/memories/:id/decision",
  "/api/operator/support/:id/projects/:id/memories/:id/withdraw",
  "/api/operator/support/:id/projects/:id/owner",
  "/api/operator/support/:id/projects/:id/promotion",
  "/api/operator/support/:id/projects/:id/rule-grants",
  "/api/operator/support/:id/projects/:id/rule-grants/:id",
  "/api/operator/support/:id/projects/:id/settings",
  "/api/operator/support/:id/projects/:id/settings/:id",
  "/api/operator/support/:id/projects/:id/summary",
  "/api/operator/support/:id/projects/:id/wiki",
  "/api/operator/support/:id/projects/:id/wiki/activity",
  "/api/operator/support/:id/projects/:id/wiki/agent-replies/:id",
  "/api/operator/support/:id/projects/:id/wiki/agent-replies/:id/remove",
  "/api/operator/support/:id/projects/:id/wiki/agent-replies/:id/send",
  "/api/operator/support/:id/projects/:id/wiki/change-items/:id",
  "/api/operator/support/:id/projects/:id/wiki/change-sets",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/approve",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/discard",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/items",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/items/:id",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/items/:id/approve",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/items/:id/regenerate",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/items/:id/reject",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/items/:id/reopen",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/preview",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/publish",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/revert",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/send-back",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/since-review",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/submit",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/threads",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/threads/:id/comments",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/threads/:id/comments/:id",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/threads/:id/reopen",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/threads/:id/resolve",
  "/api/operator/support/:id/projects/:id/wiki/change-sets/:id/threads/resolve-answered",
  "/api/operator/support/:id/projects/:id/wiki/closed-changes",
  "/api/operator/support/:id/projects/:id/wiki/exports",
  "/api/operator/support/:id/projects/:id/wiki/exports/:id",
  "/api/operator/support/:id/projects/:id/wiki/exports/:id/download",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/owner",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/passage-history",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/pending",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/read",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/threads",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/threads/:id/comments",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/threads/:id/comments/:id",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/threads/:id/reopen",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/threads/:id/resolve",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/threads/audience",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/verification",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/versions",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/versions/:id/revert",
  "/api/operator/support/:id/projects/:id/wiki/pages/:id/versions/compare",
  "/api/operator/support/:id/projects/:id/wiki/resolution-runs/:id",
  "/api/operator/support/:id/projects/:id/wiki/resolution-runs/:id/send-all",
  "/api/operator/support/:id/projects/:id/wiki/resolution-runs/:id/undo-item",
  "/api/operator/support/:id/projects/:id/wiki/review",
  "/api/operator/support/:id/projects/:id/wiki/review/:id/resolve",
  "/api/operator/support/:id/projects/:id/wiki/revision-requests",
  "/api/operator/support/:id/projects/promotions",
  "/api/operator/support/:id/projects/promotions/:id/accept",
  "/api/operator/support/:id/projects/promotions/:id/reject",
  "/api/operator/tenants",
  "/api/operator/tenants/:id",
  "/api/operator/tenants/:id/admin-mfa-reset",
  "/api/operator/tenants/:id/admins/:id/invitation",
  "/api/operator/tenants/:id/deletion",
  "/api/operator/tenants/:id/deletion/expedite",
  "/api/operator/tenants/:id/limits",
  "/api/operator/tenants/:id/reactivate",
  "/api/operator/tenants/:id/suspend",
  "/api/projects",
  "/api/projects/:id",
  "/api/projects/:id/access-requests",
  "/api/projects/:id/access-requests/:id/approve",
  "/api/projects/:id/access-requests/:id/reject",
  "/api/projects/:id/activity",
  "/api/projects/:id/conversations",
  "/api/projects/:id/conversations/:id",
  "/api/projects/:id/conversations/:id/artefacts",
  "/api/projects/:id/conversations/:id/artefacts/:id/versions/:id",
  "/api/projects/:id/conversations/:id/artefacts/:id/versions/:id/download",
  "/api/projects/:id/conversations/:id/artefacts/:id/versions/:id/file",
  "/api/projects/:id/conversations/:id/artefacts/:id/versions/:id/knowledge",
  "/api/projects/:id/conversations/:id/artefacts/:id/versions/:id/knowledge/update",
  "/api/projects/:id/conversations/:id/artefacts/:id/versions/:id/preview",
  "/api/projects/:id/conversations/:id/attachments",
  "/api/projects/:id/conversations/:id/attachments/:id",
  "/api/projects/:id/conversations/:id/attachments/:id/confirm",
  "/api/projects/:id/conversations/:id/attachments/:id/download",
  "/api/projects/:id/conversations/:id/attachments/:id/open",
  "/api/projects/:id/conversations/:id/attachments/:id/retry",
  "/api/projects/:id/conversations/:id/attachments/:id/view",
  "/api/projects/:id/conversations/:id/messages",
  "/api/projects/:id/conversations/:id/messages/:id/citations/:id",
  "/api/projects/:id/conversations/:id/messages/:id/save",
  "/api/projects/:id/conversations/:id/messages/:id/wiki",
  "/api/projects/:id/conversations/:id/project-share",
  "/api/projects/:id/conversations/:id/shares",
  "/api/projects/:id/conversations/:id/shares/:id",
  "/api/projects/:id/conversations/:id/task-proposals/:id/apply",
  "/api/projects/:id/conversations/:id/task-proposals/:id/dismiss",
  "/api/projects/:id/conversations/:id/tool-approvals/:id",
  "/api/projects/:id/conversations/:id/wiki-suggestions/:id/accept",
  "/api/projects/:id/conversations/:id/wiki-suggestions/:id/dismiss",
  "/api/projects/:id/conversations/:id/wiki-suggestions/:id/pages/:id",
  "/api/projects/:id/declassifications",
  "/api/projects/:id/declassifications/:id/withdraw",
  "/api/projects/:id/documents",
  "/api/projects/:id/documents/:id",
  "/api/projects/:id/documents/:id/confirm",
  "/api/projects/:id/documents/:id/download",
  "/api/projects/:id/documents/:id/folder",
  "/api/projects/:id/documents/:id/open",
  "/api/projects/:id/documents/:id/retry",
  "/api/projects/:id/documents/:id/view",
  "/api/projects/:id/folders",
  "/api/projects/:id/folders/:id",
  "/api/projects/:id/folders/:id/move",
  "/api/projects/:id/members",
  "/api/projects/:id/members/:id",
  "/api/projects/:id/members/groups",
  "/api/projects/:id/members/groups/:id",
  "/api/projects/:id/members/search",
  "/api/projects/:id/memories",
  "/api/projects/:id/memories/:id",
  "/api/projects/:id/memories/:id/decision",
  "/api/projects/:id/memories/:id/withdraw",
  "/api/projects/:id/model-options",
  "/api/projects/:id/owner",
  "/api/projects/:id/promotion",
  "/api/projects/:id/rule-grants",
  "/api/projects/:id/rule-grants/:id",
  "/api/projects/:id/settings",
  "/api/projects/:id/settings/:id",
  "/api/projects/:id/summary",
  "/api/projects/:id/tasks",
  "/api/projects/:id/tasks/:id",
  "/api/projects/:id/tasks/:id/comments",
  "/api/projects/:id/tasks/:id/comments/:id",
  "/api/projects/:id/tasks/:id/conversations",
  "/api/projects/:id/tasks/:id/links",
  "/api/projects/:id/tasks/:id/links/:id",
  "/api/projects/:id/tasks/assignees",
  "/api/projects/:id/wiki",
  "/api/projects/:id/wiki/activity",
  "/api/projects/:id/wiki/agent-replies/:id",
  "/api/projects/:id/wiki/agent-replies/:id/remove",
  "/api/projects/:id/wiki/agent-replies/:id/send",
  "/api/projects/:id/wiki/change-items/:id",
  "/api/projects/:id/wiki/change-sets",
  "/api/projects/:id/wiki/change-sets/:id",
  "/api/projects/:id/wiki/change-sets/:id/approve",
  "/api/projects/:id/wiki/change-sets/:id/discard",
  "/api/projects/:id/wiki/change-sets/:id/items",
  "/api/projects/:id/wiki/change-sets/:id/items/:id",
  "/api/projects/:id/wiki/change-sets/:id/items/:id/approve",
  "/api/projects/:id/wiki/change-sets/:id/items/:id/regenerate",
  "/api/projects/:id/wiki/change-sets/:id/items/:id/reject",
  "/api/projects/:id/wiki/change-sets/:id/items/:id/reopen",
  "/api/projects/:id/wiki/change-sets/:id/preview",
  "/api/projects/:id/wiki/change-sets/:id/publish",
  "/api/projects/:id/wiki/change-sets/:id/resolve",
  "/api/projects/:id/wiki/change-sets/:id/revert",
  "/api/projects/:id/wiki/change-sets/:id/send-back",
  "/api/projects/:id/wiki/change-sets/:id/since-review",
  "/api/projects/:id/wiki/change-sets/:id/submit",
  "/api/projects/:id/wiki/change-sets/:id/threads",
  "/api/projects/:id/wiki/change-sets/:id/threads/:id/comments",
  "/api/projects/:id/wiki/change-sets/:id/threads/:id/comments/:id",
  "/api/projects/:id/wiki/change-sets/:id/threads/:id/reopen",
  "/api/projects/:id/wiki/change-sets/:id/threads/:id/resolve",
  "/api/projects/:id/wiki/change-sets/:id/threads/:id/revise",
  "/api/projects/:id/wiki/change-sets/:id/threads/resolve-answered",
  "/api/projects/:id/wiki/closed-changes",
  "/api/projects/:id/wiki/exports",
  "/api/projects/:id/wiki/exports/:id",
  "/api/projects/:id/wiki/exports/:id/download",
  "/api/projects/:id/wiki/pages/:id",
  "/api/projects/:id/wiki/pages/:id/owner",
  "/api/projects/:id/wiki/pages/:id/passage-history",
  "/api/projects/:id/wiki/pages/:id/pending",
  "/api/projects/:id/wiki/pages/:id/read",
  "/api/projects/:id/wiki/pages/:id/threads",
  "/api/projects/:id/wiki/pages/:id/threads/:id/ask",
  "/api/projects/:id/wiki/pages/:id/threads/:id/comments",
  "/api/projects/:id/wiki/pages/:id/threads/:id/comments/:id",
  "/api/projects/:id/wiki/pages/:id/threads/:id/reopen",
  "/api/projects/:id/wiki/pages/:id/threads/:id/resolve",
  "/api/projects/:id/wiki/pages/:id/threads/audience",
  "/api/projects/:id/wiki/pages/:id/verification",
  "/api/projects/:id/wiki/pages/:id/versions",
  "/api/projects/:id/wiki/pages/:id/versions/:id/revert",
  "/api/projects/:id/wiki/pages/:id/versions/compare",
  "/api/projects/:id/wiki/resolution-runs/:id",
  "/api/projects/:id/wiki/resolution-runs/:id/send-all",
  "/api/projects/:id/wiki/resolution-runs/:id/undo-item",
  "/api/projects/:id/wiki/review",
  "/api/projects/:id/wiki/review/:id/resolve",
  "/api/projects/:id/wiki/revision-requests",
  "/api/projects/promotions",
  "/api/projects/promotions/:id/accept",
  "/api/projects/promotions/:id/reject",
];
